import axios from 'axios';
const send_notice_url = 'send-notice/';
const notices_url = 'notices/';

export default {
  async emailNotice (notice_pk, project_pk, estimate_pk, send_from, send_to, bcc, message) {
    let url = send_notice_url + `?notice_pk=${notice_pk}&`;

    if(project_pk !== null && project_pk !== undefined){
      url += `project_pk=${project_pk}&`;
    }

    if(estimate_pk !== null && estimate_pk !== undefined){
      url += `estimate_pk=${estimate_pk}&`;
    }

    if(send_from !== null && send_from !== undefined){
      url += `send_from=${send_from}&`;
    }

    if(send_to !== null && send_to !== undefined){
      url += `send_to=${send_to}&`;
    }

    if(bcc !== null && bcc !== undefined){
      url += `bcc=${bcc}&`;
    }

    if(message !== null && message !== undefined){
      url += `message=${message}&`;
    }

    return axios.post(url, {})
    .then((response) => {
      return response.data;
    }).catch(err => {
      console.log(err.response.data);
    });
  },
  async getNotices () {
    return axios.get(notices_url)
    .then((response) => {
      return response.data;
    }).catch(err => {
      console.log(err.response.data);
    });
  },
}